<div>
    <div class="container-fluid fixed-top ">
        <app-header></app-header>
    </div>

    <div class="container-fluid py-5 mt-5 margin-top-5" id="top-page">
        <div class="container py-5 mt-5">
        <app-password-confirm [user]="usr"></app-password-confirm>
        </div>
    </div>

    <div>
        <app-footer></app-footer>
    </div>
</div>